export default __webpack_public_path__ + "static/media/select_week.84721022.png";